module.exports = __webpack_public_path__ + "img/content5.53280c87.png";